<template>
  <v-dialog v-model="isOpen" max-width="480" persistent>
    <v-card>
      <v-card-title primary-title class="error white--text">
        Excluir {{item.type === 'FILE' ? 'arquivo' : 'pasta'}}
      </v-card-title>

      <v-card-text class="pt-6">
        <h3>
          Deseja <b>excluir</b> {{item.type === 'FILE' ? 'este arquivo' : ' a pasta'}} "{{item.name}}"?
        </h3>
        <p>Esta ação não pode ser desfeita.</p>
      </v-card-text>

      <v-divider/>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="confirmDeletion">
          Excluir
        </v-btn>
        <v-btn color="primary" @click="cancelDeletion">
          Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeletionConfirmationModal',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isOpen: false,
    deletionConfirmed: false,
  }),
  methods: {
    cancelDeletion() {
      this.isOpen = false;
      this.$emit('close');
    },
    confirmDeletion() {
      this.isOpen = false;
      this.$emit('confirm');
    },
  },
  watch: {
    open(newValue) {
      this.isOpen = newValue;
    },
  },
  beforeMount() {
    this.isOpen = this.open;
  },
};
</script>
